// extracted by mini-css-extract-plugin
module.exports = {"notificationRow":"NotificationsRow-module_notificationRow_18GJ9","bubble":"NotificationsRow-module_bubble_3V3ii"};